import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation } from "react-router-dom";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
    const fromMobileAppInUrl =
      String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
    const persistedFromMobileApp = (() => {
      try {
        const persisted = JSON.parse(
          sessionStorage.getItem("hs_user_v1") || "{}"
        );
        return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
      } catch {
        return false;
      }
    })();
    const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;

  /** Index route `/` is login — same as `/login` (was missing, so USER fired a second fetchThemeData vs loginSlice). */
  const loginPathNorm = String(location.pathname || "/").replace(/\/+$/, "") || "/";
  const isLoginEntryPath = loginPathNorm === "/" || loginPathNorm === "/login";

  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
};
    
  useEffect(() => {
    if (isLoginEntryPath) return;
    if (themeStatus === "idle") {
      dispatch(fetchThemeData({ themeId: null }));
    }
  }, [themeStatus, dispatch, location.pathname, isLoginEntryPath]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])


  useEffect(() => {
    if (themeStatus === 'succeeded' && themeData) {
      applyCustomTheme(themeData.colors);
      const applyBodyBackground = () => {
        const body = document.body;
        const bg = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
        const bgUrl = bg ? encodeURI(process.env.REACT_APP_S3_PATH + bg) : null;
        if (body.classList.contains('common-bg') && bgUrl) {
          body.style.backgroundImage = `url("${bgUrl}")`;
          body.style.backgroundSize = "100% 100%";
          body.style.backgroundRepeat = "no-repeat";
          body.style.backgroundAttachment = "fixed";
        }
      };
      applyBodyBackground();
      window.addEventListener("resize", applyBodyBackground);
      window.addEventListener("orientationchange", applyBodyBackground);
      return () => {
        window.removeEventListener("resize", applyBodyBackground);
        window.removeEventListener("orientationchange", applyBodyBackground);
      };
    }
  }, [themeStatus, themeData]);


  const handleMobileLogoActivate = (e) => {
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  return (
    <>
      <header className="upperaction">
      {isFromMobileApp ? (
        <span
          className="logo-anchor-mobile"
          role="button"
          tabIndex={0}
          onClick={handleMobileLogoActivate}
          onKeyDown={(e) => {
            if (e.key !== "Enter" && e.key !== " ") return;
            handleMobileLogoActivate(e);
          }}
        >
          <img src={logoUrl} alt="" className="logo-holder" />
        </span>
      ) : (
        <a href={process.env.REACT_APP_BASE_URL}>
          <img src={logoUrl} alt="" className="logo-holder" />
        </a>
      )}
        {!isFromMobileApp && backUrl ? (
          <div className="back-holder">
            <a href={backUrl}><button type="button" className="back-default">Back</button></a>
          </div>
        ) : null}
       
      </header>
      {children}
    </>
  );
}

export default USER;
